module.exports = __webpack_public_path__ + "img/enerfuture-logo.84f9fd1.jpg";